import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import { styled, useTheme } from '@mui/material/styles';

const IOSSwitch = styled(({...props}) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 35,
  height: 21,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.toggleBackground.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.slider.default,
      border: theme.palette.slider.border,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 19,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    backgroundColor: theme.palette.grayscale.main,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const FilterableCardHeader = ({excludable, content, toolTip, id, onSwitchChange}) => {
  const fw = 600;
  const theme = useTheme();
  const {filterableCard} = theme;


  const handleExcludeChange = React.useCallback(() => {
    onSwitchChange(id);
  },[id, onSwitchChange]);

  const renderToolTip = React.useCallback((toolTip) => {
    if (toolTip) {
      return (
        <Tooltip title={toolTip} placement="top">
          <InfoIcon
            color="secondary"
            sx={{
              fontSize: '16px',
              marginLeft: '5px',
              marginRight: '5px',
            }}
          ></InfoIcon>
        </Tooltip>
      );
    }
    return (
      <Box
        sx={{
          display: 'inline-block',
          marginLeft: '5px',
          marginRight: '5px',
        }}
      ></Box>
    );
  },[]);

  const snippetToRender = excludable ? (
    <Box sx={{ display: 'contents', marginBottom: '3px' }}>
      <Box sx={{ fontWeight: fw, color: 'primary.main', marginTop: '3px' }}>
        {renderToolTip(toolTip)}
        {content}
      </Box>
      <Box
        color="primary.main"
        sx={{
          fontSize: '11px',
          marginTop: '5px',
          marginRight: '5px',
          fontWeight: 600,
        }}
      >
        Include <IOSSwitch defaultChecked onChange={handleExcludeChange} />
      </Box>
    </Box>
  ) : (
    <>
      <Box sx={{ fontWeight: fw, color: 'primary.main' }}>
        {renderToolTip(toolTip)}
        {content}
      </Box>
    </>
  );

  return (
    <Box sx={filterableCard.header}>
      {snippetToRender}
    </Box>
  );
}

FilterableCardHeader.propTypes = {
  excludable: PropTypes.bool,
  content: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  id: PropTypes.number,
  onSwitchChange: PropTypes.func,
};

export default FilterableCardHeader;
